/* DRIVE IQ — THEME RENDERER / PERSONALIZATION IQ V2.4 PLATINUM GT AUTHORITY GARAGE THEME AUTHORITY

   Asset: theme-renderer.js

   ES5-safe.

   Owns theme, appearance, pinned categories, Taste IQ, Collections, Journey Passport.

*/

(function () {

  "use strict";

  if (window.__DRIVE_IQ_THEME_RENDERER_V2__) { return; }

  window.__DRIVE_IQ_THEME_RENDERER_V2__ = true;

  var LS = {

    PREFS: "diq_personalization_v1",

   GARAGE_THEME: "diq_garage_skin_v1",

   NATIVE_THEME: "diq_native_active_skin_v1",

    ACTIVE_THEME: "diq_active_skin_v1",

    LEGACY_THEME: "diq_theme",

    LEGACY_SKIN: "driveiq_skin",

    LEGACY_DRIVE_THEME: "driveiq_theme",

    LEGACY_THEME_V1: "diq_theme_v1"

  };

  var applyingTheme = false;

  var lastAppliedTheme = "";

  var DEFAULT_PREFS = {

    version: 1,

    appearance: {

      theme: "cockpit",

      accent: "gold",

      animations: true

    },

    adventureStyle: "",

    pinnedCategories: [

      "popular",

      "coffee",

      "food",

      "scenic",

      "local_favorites",

      "live_music"

    ],

    taste: {

      coffee: 0,

      bbq: 0,

      golf: 0,

      scenic: 0,

      patios: 0,

      liveMusic: 0,

      lakes: 0,

      breweries: 0,

      shopping: 0,

      family: 0,

      dogFriendly: 0,

      hiddenGems: 0

    },

    collections: [],

    neighborhoods: [],

    passport: {

      placesExplored: 0,

      worthTheDrive: 0,

      localFavorites: 0,

      hiddenGems: 0,

      states: [],

      lastAdventureAt: 0

    }

  };

  var THEMES = {

   american_muscle: {

     id: "american_muscle",

     label: "American Muscle",

     bodyClass: "diq-theme-american-muscle"

   },

   carbon_rs: {

     id: "carbon_rs",

     label: "Carbon RS",

     bodyClass: "diq-theme-carbon-rs"

   },

  platinum_gt: {
    id: "platinum_gt",
    label: "Platinum GT",
    bodyClass: "diq-theme-platinum-gt"
  },
    cockpit: {

      id: "cockpit",

      label: "Cockpit",

      bodyClass: "diq-theme-cockpit"

    },

    aurora: {

      id: "aurora",

      label: "Aurora",

      bodyClass: "diq-theme-aurora"

    },

    sunset: {

      id: "sunset",

      label: "Sunset",

      bodyClass: "diq-theme-sunset"

    },

    coastal: {

      id: "coastal",

      label: "Coastal",

      bodyClass: "diq-theme-coastal"

    },

    midnight_luxe: {

      id: "midnight_luxe",

      label: "Midnight Luxe",

      bodyClass: "diq-theme-midnight-luxe"

    },

    volt: {

      id: "volt",

      label: "Volt",

      bodyClass: "diq-theme-volt"

    },

    forest: {

      id: "forest",

      label: "Forest",

      bodyClass: "diq-theme-forest"

    },

    autumn: {

      id: "autumn",

      label: "Autumn",

      bodyClass: "diq-theme-autumn"

    },

    holiday: {

      id: "holiday",

      label: "Holiday",

      bodyClass: "diq-theme-holiday"

    }

  };

  function clean(v) {

    return String(v || "").replace(/\s+/g, " ").trim();

  }

  function clone(obj) {

    try {

      return JSON.parse(JSON.stringify(obj));

    } catch (e) {

      return {};

    }

  }

  function safeParse(v) {

    try {

      return JSON.parse(String(v || ""));

    } catch (e) {

      return null;

    }

  }

  function mergePrefs(base, saved) {

    var out = clone(base);

    var k;

    if (!saved) { return out; }

    for (k in saved) {

      if (!saved.hasOwnProperty(k)) { continue; }

      if (

        saved[k] &&

        typeof saved[k] === "object" &&

        !Array.isArray(saved[k]) &&

        out[k] &&

        typeof out[k] === "object" &&

        !Array.isArray(out[k])

      ) {

        out[k] = mergePrefs(out[k], saved[k]);

      } else {

        out[k] = saved[k];

      }

    }

    return out;

  }

  function loadPrefs() {

    var saved = null;

    var prefs;

    var activeTheme = "";

    var fallbackTheme = "";

    try {

      saved = safeParse(localStorage.getItem(LS.PREFS));

    } catch (e) {

      saved = null;

    }

    prefs = mergePrefs(DEFAULT_PREFS, saved);

    try {

      activeTheme = localStorage.getItem(LS.GARAGE_THEME) ||

       localStorage.getItem(LS.ACTIVE_THEME) ||

       localStorage.getItem(LS.NATIVE_THEME) || "";

      fallbackTheme =

        localStorage.getItem(LS.LEGACY_SKIN) ||

        localStorage.getItem(LS.LEGACY_DRIVE_THEME) ||

        localStorage.getItem(LS.LEGACY_THEME_V1) ||

        localStorage.getItem(LS.LEGACY_THEME) ||

        "";

    } catch (e2) {}

    if (activeTheme || fallbackTheme) {

      prefs.appearance.theme = normalizeThemeId(activeTheme || fallbackTheme);

    }

    return prefs;

  }

  /* V2.3: Non-theme personalization saves must NEVER overwrite the Garage.
     Only an explicit applyTheme() call can change the authoritative selection. */
  function savePrefs(prefs, explicitTheme) {
    var garage = "";
    var theme = normalizeThemeId(
      prefs && prefs.appearance && prefs.appearance.theme || "cockpit"
    );

    try { garage = localStorage.getItem(LS.GARAGE_THEME) || ""; } catch (e0) {}
    if (!explicitTheme && garage) { theme = normalizeThemeId(garage); }
    if (!prefs.appearance) { prefs.appearance = {}; }
    prefs.appearance.theme = theme;

    try {
      localStorage.setItem(LS.PREFS, JSON.stringify(prefs));
      localStorage.setItem(LS.ACTIVE_THEME, theme);
      localStorage.setItem(LS.GARAGE_THEME, theme);
      localStorage.setItem(LS.NATIVE_THEME, theme);
      localStorage.setItem(LS.LEGACY_THEME, theme);
      localStorage.setItem(LS.LEGACY_SKIN, theme);
      localStorage.setItem(LS.LEGACY_DRIVE_THEME, theme);
      localStorage.setItem(LS.LEGACY_THEME_V1, theme);
    } catch (e1) {}
  }

  function normalizeThemeId(themeId) {

    var t = clean(themeId).toLowerCase().replace(/[^a-z0-9]+/g, "_");

    if (t === "midnight" || t === "midnight_luxe") { return "midnight_luxe"; }

    if (t === "default") { return "cockpit"; }

   if (t === "americanmuscle" || t === "muscle" || t === "muscle_gt") { return "american_muscle"; }

   if (t === "carbonrs" || t === "carbon_rs_silver") { return "carbon_rs"; }

   if (t === "volt_gt" || t === "voltgt") { return "volt"; }

    if (THEMES[t]) { return t; }

    return "cockpit";

  }

  function removeThemeClasses() {

    var key;

    if (!document.body) { return; }

    for (key in THEMES) {

      if (THEMES.hasOwnProperty(key)) {

        document.body.classList.remove(THEMES[key].bodyClass);

      }

    }

  }

  function applyTheme(themeId, options) {

    var opts = options || {};

    var prefs = loadPrefs();

    var id = normalizeThemeId(themeId || prefs.appearance.theme);
    /* V2.4: The Garage selection is the sole owner. Other pages and old
       UI controls may repaint, but cannot change the committed choice. */
    var savedGarage = "";
    try { savedGarage = localStorage.getItem(LS.GARAGE_THEME) || ""; } catch (themeReadErr) {}
    if (savedGarage && normalizeThemeId(savedGarage) !== id) {
      id = normalizeThemeId(savedGarage);
    }
    var theme = THEMES[id] || THEMES.cockpit;

    var changed = lastAppliedTheme !== id;

    if (applyingTheme) {

      return id;

    }

    applyingTheme = true;

    try {

      prefs.appearance.theme = id;

      savePrefs(prefs, true);

      if (document.body) {

        removeThemeClasses();

        document.body.classList.add(theme.bodyClass);

        document.body.setAttribute("data-diq-theme", id);

      }

      if (document.documentElement) {

        document.documentElement.setAttribute("data-diq-theme", id);

      }

      window.DriveIQActiveSkin = id;

      lastAppliedTheme = id;

      /*

       * Dispatch only when the theme actually changed, and never echo a

       * themechange event back into another themechange loop.

       */

      if (changed && opts.silent !== true) {

        try {

          window.dispatchEvent(new CustomEvent("driveiq:themechange", {

            detail: {

              theme: id,

              skin: id,

              label: theme.label,

              source: opts.source || "theme-renderer"

            }

          }));

        } catch (e) {}

      }

    } finally {

      applyingTheme = false;

    }

    return id;

  }

  function getTheme() {

    var prefs = loadPrefs();

    return normalizeThemeId(prefs.appearance.theme);

  }

  function getThemeList() {

    var out = [];

    var key;

    for (key in THEMES) {

      if (THEMES.hasOwnProperty(key)) {

        out.push({

          id: THEMES[key].id,

          label: THEMES[key].label

        });

      }

    }

    return out;

  }

  function setAdventureStyle(style) {

    var prefs = loadPrefs();

    prefs.adventureStyle = clean(style);

    savePrefs(prefs);

    return prefs.adventureStyle;

  }

  function getAdventureStyle() {

    return loadPrefs().adventureStyle || "";

  }

  function updateTaste(key, amount) {

    var prefs = loadPrefs();

    var k = clean(key).replace(/[^a-zA-Z0-9_]/g, "");

    var n = Number(amount || 0);

    if (!k) { return prefs.taste; }

    if (!prefs.taste[k] && prefs.taste[k] !== 0) {

      prefs.taste[k] = 0;

    }

    prefs.taste[k] += n;

    if (prefs.taste[k] < -25) { prefs.taste[k] = -25; }

    if (prefs.taste[k] > 100) { prefs.taste[k] = 100; }

    savePrefs(prefs);

    return prefs.taste;

  }

  function getTaste() {

    return loadPrefs().taste || {};

  }

  function getTopTaste(limit) {

    var taste = getTaste();

    var out = [];

    var key;

    for (key in taste) {

      if (taste.hasOwnProperty(key)) {

        out.push({

          key: key,

          score: Number(taste[key] || 0)

        });

      }

    }

    out.sort(function (a, b) {

      return b.score - a.score;

    });

    return out.slice(0, Number(limit || 5));

  }

  function setPinnedCategories(items) {

    var prefs = loadPrefs();

    var out = [];

    var i;

    var id;

    for (i = 0; i < (items || []).length; i++) {

      id = clean(items[i]);

      if (id && out.indexOf(id) < 0) {

        out.push(id);

      }

    }

    prefs.pinnedCategories = out.slice(0, 12);

    savePrefs(prefs);

    return prefs.pinnedCategories;

  }

  function getPinnedCategories() {

    return loadPrefs().pinnedCategories || [];

  }

  function pinCategory(id) {

    var prefs = loadPrefs();

    var cat = clean(id);

    if (!cat) { return prefs.pinnedCategories; }

    if (prefs.pinnedCategories.indexOf(cat) < 0) {

      prefs.pinnedCategories.push(cat);

    }

    prefs.pinnedCategories = prefs.pinnedCategories.slice(0, 12);

    savePrefs(prefs);

    return prefs.pinnedCategories;

  }

  function unpinCategory(id) {

    var prefs = loadPrefs();

    var cat = clean(id);

    var out = [];

    var i;

    for (i = 0; i < prefs.pinnedCategories.length; i++) {

      if (prefs.pinnedCategories[i] !== cat) {

        out.push(prefs.pinnedCategories[i]);

      }

    }

    prefs.pinnedCategories = out;

    savePrefs(prefs);

    return prefs.pinnedCategories;

  }

  function addCollection(name) {

    var prefs = loadPrefs();

    var label = clean(name);

    var id;

    if (!label) { return null; }

    id = label.toLowerCase().replace(/[^a-z0-9]+/g, "_");

    prefs.collections.push({

      id: id + "_" + Date.now(),

      name: label,

      places: [],

      createdAt: Date.now()

    });

    savePrefs(prefs);

    return prefs.collections[prefs.collections.length - 1];

  }

  function getCollections() {

    return loadPrefs().collections || [];

  }

  function addPlaceToCollection(collectionId, place) {

    var prefs = loadPrefs();

    var i;

    var item;

    for (i = 0; i < prefs.collections.length; i++) {

      if (prefs.collections[i].id === collectionId) {

        item = {

          id: clean(place.id || place.place_id || place.label || place.name) + "_" + Date.now(),

          label: clean(place.label || place.name || "Saved Place"),

          lat: Number(place.lat || 0),

          lng: Number(place.lng || 0),

          category: clean(place.category || place.matchLabel || ""),

          savedAt: Date.now()

        };

        prefs.collections[i].places.push(item);

        savePrefs(prefs);

        return item;

      }

    }

    return null;

  }

  function recordNeighborhood(label, lat, lng) {

    var prefs = loadPrefs();

    var name = clean(label);

    var i;

    if (!name) { return prefs.neighborhoods; }

    for (i = 0; i < prefs.neighborhoods.length; i++) {

      if (prefs.neighborhoods[i].name.toLowerCase() === name.toLowerCase()) {

        prefs.neighborhoods[i].visits += 1;

        prefs.neighborhoods[i].lastVisitAt = Date.now();

        savePrefs(prefs);

        return prefs.neighborhoods;

      }

    }

    prefs.neighborhoods.push({

      name: name,

      lat: Number(lat || 0),

      lng: Number(lng || 0),

      visits: 1,

      lastVisitAt: Date.now()

    });

    savePrefs(prefs);

    return prefs.neighborhoods;

  }

  function getNeighborhoods() {

    var items = loadPrefs().neighborhoods || [];

    items.sort(function (a, b) {

      return Number(b.visits || 0) - Number(a.visits || 0);

    });

    return items;

  }

  function recordAdventure(place, signals) {

    var prefs = loadPrefs();

    var s = signals || {};

    prefs.passport.placesExplored += 1;

    prefs.passport.lastAdventureAt = Date.now();

    if (s.worthTheDrive) {

      prefs.passport.worthTheDrive += 1;

    }

    if (s.localFavorite) {

      prefs.passport.localFavorites += 1;

    }

    if (s.hiddenGem) {

      prefs.passport.hiddenGems += 1;

    }

    if (s.state) {

      if (prefs.passport.states.indexOf(s.state) < 0) {

        prefs.passport.states.push(s.state);

      }

    }

    if (place && place.category) {

      updateTaste(place.category, 2);

      prefs = loadPrefs();

    }

    savePrefs(prefs);

    return prefs.passport;

  }

  function getPassport() {

    return loadPrefs().passport || {};

  }

  function rankWithTaste(results) {

    var prefs = loadPrefs();

    var taste = prefs.taste || {};

    var out = (results || []).slice(0);

    out.sort(function (a, b) {

      return tasteScore(b, taste) - tasteScore(a, taste);

    });

    return out;

  }

  function tasteScore(item, taste) {

    var txt = (

      String(item.category || "") + " " +

      String(item.matchLabel || "") + " " +

      String(item.label || "") + " " +

      String(item.name || "")

    ).toLowerCase();

    var score = 0;

    if (txt.indexOf("coffee") > -1) { score += Number(taste.coffee || 0); }

    if (txt.indexOf("bbq") > -1 || txt.indexOf("barbecue") > -1) { score += Number(taste.bbq || 0); }

    if (txt.indexOf("golf") > -1) { score += Number(taste.golf || 0); }

    if (txt.indexOf("scenic") > -1 || txt.indexOf("sunset") > -1) { score += Number(taste.scenic || 0); }

    if (txt.indexOf("patio") > -1 || txt.indexOf("outdoor") > -1) { score += Number(taste.patios || 0); }

    if (txt.indexOf("music") > -1) { score += Number(taste.liveMusic || 0); }

    if (txt.indexOf("lake") > -1 || txt.indexOf("waterfront") > -1) { score += Number(taste.lakes || 0); }

    if (txt.indexOf("brewery") > -1 || txt.indexOf("brewing") > -1) { score += Number(taste.breweries || 0); }

    if (txt.indexOf("shop") > -1 || txt.indexOf("boutique") > -1) { score += Number(taste.shopping || 0); }

    if (txt.indexOf("family") > -1 || txt.indexOf("kids") > -1) { score += Number(taste.family || 0); }

    if (txt.indexOf("dog") > -1 || txt.indexOf("pet") > -1) { score += Number(taste.dogFriendly || 0); }

    if (txt.indexOf("hidden") > -1 || txt.indexOf("gem") > -1) { score += Number(taste.hiddenGems || 0); }

    return score;

  }

  function resetPersonalization() {

    savePrefs(clone(DEFAULT_PREFS));

    applyTheme(DEFAULT_PREFS.appearance.theme);

    return loadPrefs();

  }

  function init() {

    var prefs = loadPrefs();

    if (!prefs.appearance || !prefs.appearance.theme) {

      prefs.appearance = clone(DEFAULT_PREFS.appearance);

      savePrefs(prefs);

    }

    applyTheme(prefs.appearance.theme, {

      silent: true,

      source: "theme-renderer-init"

    });

  }

  function onExternalThemeChange(event) {

    var detail = event && event.detail ? event.detail : {};

    var theme = detail.theme || detail.skin || "";

    if (!theme) { return; }

    theme = normalizeThemeId(theme);

    /* The Garage persists before broadcasting a legitimate selection.
       A late stale event must not replace that already-saved selection. */
    var garage = "";
    try { garage = localStorage.getItem(LS.GARAGE_THEME) || ""; } catch (e0) {}
    if (garage && theme !== normalizeThemeId(garage)) { return; }

    if (theme === getTheme() && theme === lastAppliedTheme) {

      return;

    }

    applyTheme(theme, {

      silent: true,

      source: "external-themechange"

    });

  }

  window.addEventListener(

    "driveiq:themechange",

    onExternalThemeChange,

    false

  );

  window.DriveIQ = window.DriveIQ || {};

  window.DriveIQ.Personalization = {

    load: loadPrefs,

    save: savePrefs,

    reset: resetPersonalization,

    applyTheme: applyTheme,

    getTheme: getTheme,

    getThemeList: getThemeList,

    setAdventureStyle: setAdventureStyle,

    getAdventureStyle: getAdventureStyle,

    updateTaste: updateTaste,

    getTaste: getTaste,

    getTopTaste: getTopTaste,

    rankWithTaste: rankWithTaste,

    setPinnedCategories: setPinnedCategories,

    getPinnedCategories: getPinnedCategories,

    pinCategory: pinCategory,

    unpinCategory: unpinCategory,

    addCollection: addCollection,

    getCollections: getCollections,

    addPlaceToCollection: addPlaceToCollection,

    recordNeighborhood: recordNeighborhood,

    getNeighborhoods: getNeighborhoods,

    recordAdventure: recordAdventure,

    getPassport: getPassport

  };

  window.DriveIQ.getPersonalization = loadPrefs;

  window.DriveIQ.getTheme = getTheme;

  window.DriveIQ.applyTheme = applyTheme;

  window.DriveIQ.updateTaste = updateTaste;

  window.DriveIQ.getTaste = getTaste;

  window.DriveIQ.getPinnedCategories = getPinnedCategories;

  window.DriveIQ.rankWithTaste = rankWithTaste;

  if (document.readyState === "loading") {

    document.addEventListener("DOMContentLoaded", init);

  } else {

    init();

  }

})();